/**
 * @module app.um
 */

import { DynamicViews } from 'app/shared/config/modules';
import { PLATFORM } from 'aurelia-pal';

export function getUtilizationManagementTaskTypes(): DynamicViews {
    return {
        'UM.Auth': [
            {
                title: 'um:taskTypes.auth.$title',
                url: PLATFORM.moduleName('app/um/components/tasks/smart-auth'),
                icon: 'um:icons.auth'
            }
        ]
    };
}
